"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TypedObjectAccessor_1 = tslib_1.__importDefault(require("./TypedObjectAccessor"));
var SSPFilePropertiesAccessor = (function (_super) {
    tslib_1.__extends(SSPFilePropertiesAccessor, _super);
    function SSPFilePropertiesAccessor(target) {
        return _super.call(this, target) || this;
    }
    Object.defineProperty(SSPFilePropertiesAccessor.prototype, "fileHash", {
        get: function () {
            return this.str('FileHash');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPFilePropertiesAccessor.prototype, "fileType", {
        get: function () {
            return this.str('FileType');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPFilePropertiesAccessor.prototype, "originalFilename", {
        get: function () {
            return this.str('OriginalFilename');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPFilePropertiesAccessor.prototype, "originalModifiedTime", {
        get: function () {
            return this.w3cddate('OriginalMtime');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPFilePropertiesAccessor.prototype, "size", {
        get: function () {
            return this.integer('Size');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPFilePropertiesAccessor.prototype, "fileMeta", {
        get: function () {
            return this.objacc('FileMeta');
        },
        enumerable: false,
        configurable: true
    });
    return SSPFilePropertiesAccessor;
}(TypedObjectAccessor_1.default));
exports.default = SSPFilePropertiesAccessor;
